module.exports = __webpack_public_path__ + "static/img/mastercard.b92f7fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/common/creditCards/mastercard.svg
// module id = CH6u
// module chunks = 2